var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, List, ListItem, Table } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import config from '../../Config';
import { addLanguageSlugToUrl } from '../../util/PathUtil';
import { injectStores } from '../../util/StoresUtil';
let InvoiceTable = class InvoiceTable extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "invoiceStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    renderInvoiceTableContents(displayedInvoiceList) {
        const invoiceRows = [];
        displayedInvoiceList.forEach((invoice) => {
            invoiceRows.push(this.getInvoiceTableRow(invoice));
        });
        return invoiceRows;
    }
    getInvoiceTableRow(invoice) {
        const { translate, currentLanguage } = this.translateStore;
        const settlementTranslationKey = invoice.isPartiallyUnsettled ? 'billing.invoice-notice-partly-settled' : 'billing.invoice-notice-unsettled';
        const amountDisplayed = `${invoice.amount} ${translate('billing.invoice-currency-sign')}`;
        const invoiceNumberWithInvoiceText = `${translate('billing.invoice-name')} ${invoice.invoiceNumber}`;
        const dueDate = `${translate('billing.invoice-duedate')} `;
        const invoiceSum = `${translate('billing.invoice-sum')} `;
        if (invoice.isPartiallyUnsettled || invoice.isTotallyUnsettled) {
            const unsettledAmountClassNames = `text-small${invoice.isDueDatePassed ? ' text-sale' : ''}`;
            return (React.createElement("tr", { key: invoice.invoiceNumber },
                React.createElement("td", null,
                    React.createElement(Button, { text: invoiceNumberWithInvoiceText, link: true, url: addLanguageSlugToUrl(config.billsUrl, currentLanguage) }),
                    React.createElement("p", { className: unsettledAmountClassNames },
                        dueDate,
                        React.createElement("strong", null, invoice.dueDate))),
                React.createElement("td", { className: "text-small text-right" },
                    React.createElement("p", { className: "text-sale" }, translate(settlementTranslationKey)),
                    React.createElement("p", null,
                        invoiceSum,
                        React.createElement("strong", null, amountDisplayed)))));
        }
        return (React.createElement("tr", { key: invoice.invoiceNumber },
            React.createElement("td", null,
                React.createElement(Button, { text: invoiceNumberWithInvoiceText, link: true, url: addLanguageSlugToUrl(config.billsUrl, currentLanguage) }),
                React.createElement("p", { className: "text-small" },
                    dueDate,
                    React.createElement("strong", null, invoice.dueDate))),
            React.createElement("td", { className: "text-small text-right" },
                React.createElement(List, { type: "icon", icon: "#check" },
                    React.createElement(ListItem, null, translate('billing.invoice-notice-settled'))),
                invoiceSum,
                React.createElement("strong", null, amountDisplayed))));
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(Table, null,
                React.createElement("tbody", null, this.renderInvoiceTableContents(this.invoiceStore.invoicesWrapper.invoices)))));
    }
};
InvoiceTable = __decorate([
    injectStores,
    observer
], InvoiceTable);
export default InvoiceTable;
